// Mobile header (marketplace-style nav) open/close + sticky offset tracking
(function () {
    var header = document.querySelector('.header');
    var nav = document.getElementById('header-navigation');
    var toggler = document.getElementById('header-menu-toggler');
    if (!header || !nav || !toggler) return;

    function updateHeaderBottom() {
        document.documentElement.style.setProperty('--header-bottom', header.getBoundingClientRect().bottom + 'px');
    }
    updateHeaderBottom();
    window.addEventListener('resize', updateHeaderBottom, { passive: true });
    window.addEventListener('scroll', updateHeaderBottom, { passive: true });

    toggler.addEventListener('click', function () {
        var isOpen = header.classList.toggle('open');
        nav.classList.toggle('open', isOpen);
        toggler.classList.toggle('open', isOpen);
    });

    window.addEventListener('resize', function () {
        if (window.innerWidth > 1200) {
            header.classList.remove('open');
            nav.classList.remove('open');
            toggler.classList.remove('open');
        }
    });

    window.addEventListener('scroll', function () {
        if (header.classList.contains('open')) {
            header.classList.remove('open');
            nav.classList.remove('open');
            toggler.classList.remove('open');
        }
    }, { passive: true });
})();

// "Dodaj działkę" split button dropdown
(function () {
    document.querySelectorAll('[data-split-button]').forEach(function (root) {
        var toggle = root.querySelector('[data-split-button-toggle]');
        if (!toggle) return;

        toggle.addEventListener('click', function (e) {
            e.stopPropagation();
            var isOpen = root.classList.toggle('open');
            toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });

        document.addEventListener('click', function (e) {
            if (!root.contains(e.target)) {
                root.classList.remove('open');
                toggle.setAttribute('aria-expanded', 'false');
            }
        });
    });
})();

// Secondary navbar (ozegen.ai style) burger menu + language dropdown
(function () {
    var navbar = document.querySelector('.ozegen-navbar');
    if (!navbar) return;

    var toggleBtn = navbar.querySelector('.ozegen-navbar__toggle');
    var nav = navbar.querySelector('.ozegen-navbar__nav');

    // burger menu open/close (vanilla replacement for the jQuery slideToggle in scripts.js —
    // no jQuery dependency assumed on the host page)
    toggleBtn.addEventListener('click', function () {
        var isOpen = toggleBtn.classList.toggle('is-active');
        nav.classList.toggle('is-open', isOpen);
    });

    // close mobile menu after clicking a nav link (matches original behavior)
    navbar.querySelectorAll('.ozegen-navbar__menu-link').forEach(function (link) {
        link.addEventListener('click', function () {
            if (window.innerWidth <= 991) {
                toggleBtn.classList.remove('is-active');
                nav.classList.remove('is-open');
            }
        });
    });

    // reset mobile state if resized back to desktop
    window.addEventListener('resize', function () {
        if (window.innerWidth > 991) {
            toggleBtn.classList.remove('is-active');
            nav.classList.remove('is-open');
        }
    });

    // language dropdown (vanilla port of langSwitcher.js — only the open/close +
    // current-flag-swap behavior; the full-page translation logic from the original
    // was tied to locale dictionaries (locales/lang-pl.js / lang-en.js) that only
    // make sense on the original site, so it's intentionally left out here)
    var langCurrent = navbar.querySelector('.ozegen-navbar__lang-current');
    var langMenu = navbar.querySelector('.ozegen-navbar__lang-menu');
    var mobileLangItems = navbar.querySelectorAll('.ozegen-navbar__lang--mobile [data-lang-id]');

    if (langCurrent && langMenu) {
        langCurrent.addEventListener('click', function () {
            langMenu.classList.toggle('is-open');
        });

        langMenu.querySelectorAll('[data-lang-id]').forEach(function (item) {
            item.addEventListener('click', function () {
                var langId = item.dataset.langId;
                var flagSrc = item.querySelector('img').getAttribute('src');

                langCurrent.innerHTML = '<img src="' + flagSrc + '" alt=""> ' + langId.toUpperCase();
                langMenu.classList.remove('is-open');

                mobileLangItems.forEach(function (el) {
                    el.classList.toggle('is-current', el.dataset.langId === langId);
                });
            });
        });
    }
})();
